import { Injectable } from '@angular/core';
import { ClientSearchResult } from '../../domain/models/client-search-result.model';
import { ClientSearchResultDto } from '../dtos/party-search.dto';

@Injectable()
export class ClientSearchResultMapper {
  public toClientSearchResult(dto: ClientSearchResultDto): ClientSearchResult {
    return {
      externalId: dto.ExternalId,
      fullName: dto.FullName,
    };
  }
}
